import GroupExpandRenderer from "src/components/common/AgGrid/GroupExpandRenderer";
import styles from "src/styles/agGridCustom.module.scss";
import { setDateFormat } from "src/utils";
import { intOrDash, numberOrDash } from "src/utils/number";

export const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: false,
};

export const autoGroupColumnDef = {
    headerName: "Borrower",
    field: "borrower",
    minWidth: 150,
    width: 150,
    cellRendererParams: {
        suppressCount: true,
    },
    headerClass: styles.agHeaderLeftAlign,
    sort: "asc",
    sortIndex: 0,
    pinned: "left",
    filter: true, // We need server to give filter options
    cellRenderer: (params) => {
        return params.node.group ? params.value : "";
    },
};

export const postTradePositionsColumnDefs = [
    {
        headerName: "Borrower",
        field: "borrower",
        width: 150,
        minWidth: 150,
        hide: true,
        filter: true,
        rowGroup: true,
    },
    {
        headerName: "Outstanding Trades",
        field: "outstanding_trades",
        width: 150,
        minWidth: 150,
        cellRenderer: (params) => {
            return params.node.group ? GroupExpandRenderer(params) : "";
        },
        pinned: "left",
        aggFunc: "count",
        headerClass: [styles.agHeaderRightAlign],
    },
    {
        headerName: "Ticker",
        field: "ticker",
        width: 100,
        minWidth: 100,
        filter: true, // We need server to give filter options
        headerClass: [styles.agHeaderLeftAlign],
    },
    {
        headerName: "Trade ID",
        field: "trade_id",
        width: 120,
        minWidth: 120,
        filter: true, // We need server to give filter options
        headerClass: [styles.agHeaderLeftAlign],
    },
    {
        headerName: "Mark Date",
        field: "mark_date",
        width: 120,
        minWidth: 120,
        headerClass: [styles.agHeaderLeftAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : setDateFormat(value, "/") || "-",
    },
    {
        headerName: "Outstanding Qty",
        field: "outstanding_qty",
        width: 120,
        minWidth: 120,
        type: "numericColumn",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : intOrDash({ value }),
    },
    {
        headerName: "Mark Price",
        field: "mark_price",
        width: 120,
        minWidth: 120,
        type: "numericColumn",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : numberOrDash({ value }),
    },
    {
        headerName: "Notional Outstanding",
        field: "notional_outstanding",
        width: 150,
        minWidth: 150,
        type: "numericColumn",
        sort: "desc",
        sortIndex: 1,
        aggFunc: "sum",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ value }) => numberOrDash({ value }),
    },
    {
        headerName: "Margin (%)",
        field: "margin",
        width: 120,
        minWidth: 120,
        type: "numericColumn",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : numberOrDash({ value }),
    },
    {
        headerName: "Required Collateral",
        field: "required_collateral",
        width: 150,
        minWidth: 150,
        type: "numericColumn",
        aggFunc: "sum",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ value }) => numberOrDash({ value }),
    },
    {
        headerName: "Rate",
        field: "rate",
        width: 100,
        minWidth: 100,
        type: "numericColumn",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : numberOrDash({ value }),
    },
    {
        headerName: "Settlement Date",
        field: "settlement_date",
        width: 120,
        minWidth: 120,
        filter: true, // We need server to give filter options
        headerClass: [styles.agHeaderLeftAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : setDateFormat(value, "/") || "-",
    },
    {
        headerName: "Div (%)",
        field: "div_percent",
        width: 100,
        minWidth: 100,
        type: "numericColumn",
        headerClass: [styles.agHeaderRightAlign],
        valueFormatter: ({ node, value }) =>
            node.group ? "" : numberOrDash({ value }),
    },
];
